import React from "react";
import { Title, useMantineTheme } from "@mantine/core";

interface Heading5Props {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
}

/**
 * Heading5 - Styled H5 component
 * Usage: <Heading5>Small Title</Heading5>
 */
export const Heading5: React.FC<Heading5Props> = ({ children, className, style }) => {
  const theme = useMantineTheme();
  const other = theme.other as Record<string, string>;

  return (
    <Title
      order={5}
      className={className}
      style={{
        color: other.textPrimary,
        fontWeight: 600,
        ...style,
      }}
    >
      {children}
    </Title>
  );
};

export default Heading5;
